const Form075EN = {
    stepName: {
        importantNotes: "Important Notes",
        workflow: "Application Workflow",
        information: "NAC20{{schoolyear}}",
        studentInformation: "Appendix NAC-1",
        confirmation: "Confirmation",
    },
    workflow: {
        title1: "Application Flow",
        title2: "Actions available",
        title3: "Remarks",
        tr1: {
            cell1: "(1) Applicant",
            cell2: [
                "Fill the application form;",
                "Preview the summary of application and student particulars (if applicable) on screen and submit it to 1<sup>st</sup> Approver; and",
                "After submission, preview the application form in PDF format.",
            ],
            cell3: "If the Applicant would like to preview the application form in PDF format before submitting to Approvers, please set both Applicant and 1<sup>st</sup> Approver as the same person.",
        },
        tr2: {
            cell1: "(2) 1<sup>st</sup> Approver",
            cell2: [
                "Preview the application form in PDF format;",
                "Preview/revise the application on screen and submit it to 2<sup>nd</sup> Approver; or",
                "Return the application to the Applicant.",
            ],
            cell3: "By default, if 1<sup>st</sup> Approver and 2<sup>nd</sup> Approver are the same person (usually school head), relevant personnel have to submit the form as 1<sup>st</sup> Approver and 2<sup>nd</sup> Approver (two times in total) such that EDB can receive the application.",
        },
        tr3: {
            cell1: "(3) 2<sup>nd</sup> Approver",
            cell2: [
                "Preview the application form in PDF format;",
                "Preview/revise the application on screen and submit it to EDB; or",
                "Return the application to the Applicant.",
            ],
            cell3IsGovernmentSchool:
                "If the eForm could not be electronically signed by the School Head of government school as required, please set School Head as 2<sup>nd</sup> Approver and submit the electronic application to EDB. Meanwhile, School Head should sign on the printed copy and submit to EDB together with the supporting documents (if applicable).",
            cell3IsNonGovernmentSchool:
                "If the eForm could not be electronically signed by the School Supervisor of non-government school as required, please set School Head as 2<sup>nd</sup> Approver and submit the electronic application to EDB. Meanwhile, School Supervisor should sign on the printed copy and submit to EDB together with the supporting documents (if applicable).",
        },
        tr4: {
            cell1: "(4) EDB",
            cell2: [
                "Receive the application; or",
                "Return the application to the Applicant.",
            ],
            cell3: "EDB will contact schools as necessary.",
        },
        note: "If schools would like to revise the above Application Flow, please contact the Master School Administrator (MSA) (e.g. School Executive Officer of your school). He/she could make reference to “Electronic Application Form – FAQs and User Guide” (the part on “Delegating Applicant and Approvers”) as provided at EDB website (<a href='https://www.edb.gov.hk/en/student-parents/newly-arrived-children/sbss/index.html' target='_blank'>https://www.edb.gov.hk/en/student-parents/newly-arrived-children/sbss/index.html</a>).",
        workflowConfirm: "The Application Flow shown above is acknowledged. ",
    },
    label: {
        SBSSGrant: "School-Based Support Scheme (SBSS) Grant",
        detailOfSBSSGrant: "Details of SBSS Grant",
        note: "Information Collection Statement",
        schoolNo: "School No.",
        location: "Location ID",
        session: "Session",
        sessionOp: {
            am: "AM",
            pm: "PM",
            wholeDay: "WD",
        },
        num: "No.",
        strn: "Student Reference Number (STRN)",
        typeOfStudent: "Type of Student",
        typeOp: {
            NAC: "NAC from the Mainland",
            NCS: "NCS",
            Returnee: "Returnee",
        },
        nameEn: "Name of Student (English)",
        nameCn: "Name of Student (Chinese)",
        sex: "Gender",
        sexOp: {
            Male: "Male",
            Female: "Female",
        },
        birth: "Date of Birth",
        level: "Level Admitted",
        firstDay: "First Day of Attending Applicant School",
        dateOfArrival:
            "Date of Arrival in Hong Kong(Refer to the Immigration Dept's date chop on the One-way Permit/the Passport or the date declared by parent if applicable)",
        dateOfArrival2:
            'Note: For cross-boundary student born in Hong Kong, please fill in "Not Applicable (CBS)"',
        hkBorn: "HK-born student",
        crossBoundary: "Cross-boundary student",
        yesOrNo: {
            yes: "Yes",
            no: "No",
        },
        schoolName: "Name of School",
        telNo: "Telephone No.",
        faxNo: "Fax No.",
        nameOfContactPerson: "Name of Teacher/Staff in-charge of School",
        postOfContactPerson: "Post Title of Teacher/Staff in-charge of School",
        schoolLevel: "School Level",
        schoolLevelOption: {
            primary: "Primary",
            secondary: "Secondary",
        },
        supervisorOrPrincipal: "Supervisor / School Head",
        supervisorOrPrincipalOption: {
            supervisor: "Supervisor",
            principal: "School Head",
        },
        applyTitle: "Please Select",
        formType: {
            schoolBasedSupportSchemeGrant:
                "Application for the School-Based Support Scheme Grant ({{schoolyear}} school year)",
            grantSummaryAndAdvancePayment:
                "School-Based Support Scheme (SBSS) Grant Summary of Application and Advance Payment",
        },
        supervisorOrSchoolHeadName:
            "Name of Supervisor / School Head (for government schools)",
        supervisorName: "Name of Supervisor",
        schoolHeadName: "Name of School Head",
        submitType: "I want to submit this application form",
        submitTypeOption: {
            iamSmart: "with my “iAM Smart+” account",
            scannedSignature: "with my scanned signature",
            electronicSignature: "with an electronic signature",
        },
        titleList: [
            "1. Applying for the SBSS Grant for the actual number of students concerned who were admitted in the {{schoolyear}} school year.",
            "2. Applying for advance payment for the {{schoolYearForAdvancePayment}} school year",
            "3. My school's particulars are as follows:",
        ],
        informationTitle: "Summary of Application and Advance Payment",
        formTextDeclare:
            "The number of children apply for SBSS Grant are listed below:",
        noteSuperScript: "Note",
        formText1a: "I wish to apply for the SBSS Grant for a total of ",
        formText1b:
            "students concerned in the {{schoolyear}} school year. Their details are shown in the Appendix NAC-1 which are correct to the best of my knowledge. I confirm that we have provided support services for these students.",
        formText1c:
            "Note: To be filled in by system after the completion of Step 4.",
        formText2a:
            "I wish to apply for the advance payment of the SBSS Grant for the {{schoolYearForAdvancePayment}} school year. It is ",
        formText2b: "estimated",
        formText2c: " that my school will admit about",
        formText2d:
            "children during the period of {{periodForAdvancePayment}}.",
        date: "Date",
        defaultSetting: "Default Setting: Student Particulars",
        appendix: "Appendix NAC-1: Student Particulars",
        levelOptions: {
            p1: "P.1",
            p2: "P.2",
            p3: "P.3",
            p4: "P.4",
            p5: "P.5",
            p6: "P.6",
            s1: "S.1",
            s2: "S.2",
            s3: "S.3",
            s4: "S.4",
            s5: "S.5",
            s6: "S.6",
        },
        beforePrintIsGovernmentSchool:
            "Please remind 2<sup>nd</sup> Approver of your school to sign and submit the application to EDB.  In general, School Head would be the 2<sup>nd</sup> Approver for government schools.",
        beforePrintIsNotGovernmentSchool:
            "Please remind 2<sup>nd</sup> Approver of your school to sign and submit the application to EDB.  In general, School Supervisor would be the 2<sup>nd</sup> Approver for non-government schools.",
        printPdfTips:
            "Please print and send the application forms, together with the supporting documents of the children (applied for the {{schoolyear}} school year), to the Placement and Support Section of EDB at Room 1424, 14/F, Wu Chung House, 213 Queen’s Road East, Wan Chai, Hong Kong by post or by hand <b><u>{{note}}</u></b>.",
        printPdfTips2:
            "If the eForm is not electronically signed by the School Supervisor / School Head as required, please sign on the printed copy.",
        enteredStudents:
            "You have entered {{enteredStudents}} students data, please be reminded to save the form regularly.",
        beforeRefIsGovernmentSchool:
            "If the eForm could not be electronically signed by the School Head of government school as required, School Head should sign on the printed copy and submit to EDB together with the supporting documents (if applicable).",
        beforeRefIsNotGovernmentSchool:
            "If the eForm could not be electronically signed by the School Supervisor of non-government school as required, School Supervisor should sign on the printed copy and submit to EDB together with the supporting documents (if applicable).",
    },
    button: {
        addStudent: "Add a student",
        addStudentWithDefaults: "Add a student with default values",
        add5StudentsWithDefaults: "Add 5 students with default values",
    },
    popUp: {
        next: {
            msg: "Submit application without {{schoolyear}} students?",
            confirm: "CONFIRM",
            cancel: "CANCEL",
        },
        alert: {
            returnee:
                "For the applications from returnee children, please provide the <b><u>Permanent HKID</b></u>’s copies of <b><u>both</b></u> Father <b><u>and</b></u> Mother of the student as one of the supporting documents.  If such documents are not available, school may check if the student fits the criteria and conditions for applying  as ‘NAC from the Mainland’ or ‘NCS’.",
        },
    },
    note: {
        note1: {
            title: `1.	The personal data provided by you in this form and appendix will be used by the Education Bureau(EDB) for one or more of the following purposes:`,
            subtitle: "Purpose of Collection",
            content1:
                "(a)	Activities relating to the processing, authentication, assessment on eligibility and counter-checking of the application for SBSS Grant for Newly-Arrived Children;",
            content2:
                "(b)	Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication, assessment on eligibility and counter-checking of the application mentioned in (a) above;",
            content3:
                "(c)	Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of EDB; and",
            content4:
                "(d)	Activities relating to compilation of statistics, research and Government publications.",
        },
        note2: {
            title: `2.		The provision of personal data required by this form and appendix and during the processing of this form and appendix is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.`,
        },
        note3: {
            title: `3.	The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-`,
            subtitle: "Classes of Transferees",
            content1:
                "(a)	other Government bureaux and departments for the purposes mentioned in paragraph 1 above; ",
            content2:
                "(b)	the school to which the form and appendix relate for the purposes mentioned in paragraph 1 above;",
            content3:
                "(c)	where you have given your prescribed consent to such disclosure; and",
            content4:
                "(d)	where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
        note4: {
            title: `4.	You have the right to request access to and correction of your personal data held by EDB.  Request for access to or correction of personal data should be made in writing to Assistant Education Officer (Placement and Support)31 at Room 1424, 14/F, Wu Chung House, 213 Queen’s Road East, Wanchai, Hong Kong or email to `,
            subtitle: "Access to Personal Data",
        },
    },
    email: "aeops31@edb.gov.hk",
    emailEnd: ".",
    errorMsg: {
        alphabetsOnly: "Character type (alphabets only)",
        chineseOnly: "Character type (chinese only)",
        arrayRule:
            "The total number of students must be same as the number filled in item 1",
        maxNum: "The max number of student is {{max}}",
        minNum: "The min number of student is {{min}}",
        dateRule: "Please select a date no later than {{targetDate}}",
        least5YearsBefore:
            "The student must be at least 5 years old at the time of submission",
        duplicatedSTRN:
            "The STRN of {{duplicatedOrder}} is the same, please check and rectify.",
        within1Year:
            "The date of Arrival in Hong Kong and First Day of Attending Applicant School which must be within 1 year.",
        arrivalAfterBirth:
            "Date of Arrival in Hong Kong must be later than Date of Birth. ",
    },
};
export default Form075EN;
